import PropTypes from 'prop-types';
import React from 'react';

/**
 * Renders a link to an external website.
 *
 * @param {string} href The URL to be rendered.
 * @param {*} children The children to render as content.
 * @param {number} tabIndex The tab index for the link.
 * @param {boolean} download Whether or not this should be a download link.
 *
 * @return {Element} The rendered link.
 */
const ExternalLink = ({ href, children = null, tabIndex = 0, download = false }) => (
  <a rel="noopener noreferrer" target="_blank" href={href} tabIndex={tabIndex} download={download}>
    {children}
  </a>
);

ExternalLink.propTypes = {
  tabIndex: PropTypes.number,
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string])),
  ]),
  download: PropTypes.bool,
};

export default ExternalLink;
